module.exports = __webpack_public_path__ + "static/media/seeds-of-life-desktop.7b024e8d.jpg";